<!-- Beware! Do NOT use (ngSubmit)="onSubmit()" -->
<form #formElem [formGroup]="form">
  <ion-grid class="c3-full-width">
    <ion-row>
      <!-- drugs search and add -->
      <ion-col size="12">
        <h3>Farmaci</h3>

        <div class="c3-flex ion-align-items-start">
          <ion-icon
            size="large"
            [src]="'information-outline' | getIcon"
            color="secondary"
            class="ion-margin-end"
          >
          </ion-icon>

          <div class="c3-flex-column">
            <ion-note>
              <span>
                Verranno generate <strong>{{ ONCO_DRUGS.length }}</strong> terapie basate sui
                seguenti farmaci:
              </span>
            </ion-note>

            <ion-list>
              <ion-item *ngFor="let drug of ONCO_DRUGS" lines="none">
                <div class="c3-flex-column">
                  <ion-label>{{ drug.name }}</ion-label>
                  <ion-note>
                    <small> {{ drug.active_ingredient }} </small>
                    <span>, </span>
                    <small> {{ drug.form }} - {{ drug.box }}</small>
                    <span>, </span>
                    <small>Codice: {{ drug._id }}</small>
                  </ion-note>
                </div>
              </ion-item>
            </ion-list>
          </div>
        </div>
      </ion-col>

      <!-- ---------------------------------------------------------------------------------------------------- -->
      <!-- capecitabine-based therapy -->

      <ion-col size="12" size-md="12" class="ion-margin-top">
        <h3>Parametri calcolo dosaggio</h3>

        <ion-note>
          <p>
            Inserisci i parametri necessari per calcolare le dosi di farmaco che il paziente dovrà
            assumere al giorno durante il periodio di terapia.
          </p>
        </ion-note>

        <ion-grid>
          <ion-row>
            <!-- start date -->
            <ion-col size="12" size-md="12">
              <ion-item>
                <ion-label position="stacked">Giorno di inizio della terapia</ion-label>
                <ion-input
                  type="date"
                  formControlName="startDate"
                  [min]="todayStr"
                  required
                ></ion-input>
              </ion-item>
            </ion-col>

            <ng-container formGroupName="capecitabineData">
              <ion-col size="12" size-md="4">
                <ion-item>
                  <ion-label position="stacked">Durata ciclo</ion-label>
                  <ion-input type="number" formControlName="cycleDuration" min="1" step="1">
                  </ion-input>
                  <ion-note slot="end">giorni</ion-note>
                </ion-item>
              </ion-col>

              <ion-col size="12" size-md="4">
                <ion-item>
                  <ion-label position="stacked">Intervallo tra cicli</ion-label>
                  <ion-input type="number" formControlName="cycleInterval" min="0" step="1">
                  </ion-input>
                  <ion-note slot="end">giorni</ion-note>
                </ion-item>
              </ion-col>

              <ion-col size="12" size-md="4">
                <ion-item>
                  <ion-label position="stacked">Numero cicli</ion-label>
                  <ion-input
                    type="number"
                    formControlName="cycleNumber"
                    min="1"
                    step="1"
                  ></ion-input>
                  <ion-note slot="end">giorni</ion-note>
                </ion-item>
              </ion-col>

              <ion-col size="12" size-md="4">
                <ion-item>
                  <ion-label position="stacked">Percentuale dosaggio</ion-label>
                  <ion-input
                    type="number"
                    formControlName="dosePercentage"
                    min="0"
                    max="100"
                    step="1"
                  >
                  </ion-input>
                  <ion-note slot="end">%</ion-note>
                </ion-item>
              </ion-col>

              <ion-col size="12" size-md="4">
                <ion-item>
                  <ion-label position="stacked">Superficie corporea</ion-label>
                  <ion-input type="number" formControlName="bodyArea" min="0"></ion-input>
                  <ion-note slot="end">mq</ion-note>
                </ion-item>
              </ion-col>

              <ion-col size="12" size-md="">
                <ion-item>
                  <ion-label position="stacked">Dosaggio</ion-label>
                  <ion-input type="number" formControlName="dose" min="0" step="1"></ion-input>
                  <ion-note slot="end">mg/mq (die)</ion-note>
                </ion-item>
              </ion-col>

              <ion-col size="12" size-md="6">
                <ion-item>
                  <ion-label position="stacked">Orario assunzione mattutina</ion-label>
                  <ion-input type="time" formControlName="morningAssumptionTime"></ion-input>
                </ion-item>
              </ion-col>

              <ion-col size="12" size-md="6">
                <ion-item>
                  <ion-label position="stacked">Orario assunzione pomeridiana</ion-label>
                  <ion-input type="time" formControlName="afternoonAssumptionTime"></ion-input>
                </ion-item>
              </ion-col>
            </ng-container>
          </ion-row>
        </ion-grid>
      </ion-col>

      <!-- ---------------------------------------------------------------------------------------------------- -->
      <!-- summary -->

      <ion-col size="12" *ngIf="form.invalid" class="ion-margin-top">
        <div class="c3-flex ion-align-items-center">
          <ion-icon
            size="small"
            [src]="'information-outline' | getIcon"
            color="secondary"
            class="ion-margin-end"
          >
          </ion-icon>
          <ion-note>
            Una volta inseriti tutti i parametri verranno mostrate qua sotto le assunzioni
            necessarie giorno per giorno
          </ion-note>
        </div>
      </ion-col>

      <ion-col size="12" *ngIf="calculatedParams">
        <h3>Riepilogo assunzioni giornaliere</h3>

        <ion-note>
          <span>
            La tabella sottostante riassume le dosi giornaliere di
            <strong>XELODA*60CPR RIV 150MG</strong> e <strong>XELODA*120CPR RIV 500MG</strong> che
            il paziente dovrà assumere al mattino e al pomeriggio calcolate in base ai parametri
            indicati.
          </span>
        </ion-note>

        <ion-item lines="none" class="ion-margin-top">
          <ion-label
            >Dose effettiva: <strong>{{ calculatedParams?.actualDose }} mg (die)</strong></ion-label
          >
        </ion-item>

        <ion-item lines="none">
          <ion-label
            >Data termine terapia:
            <strong>{{ calculatedParams?.endDate | date: "dd/MM/yyyy" }}</strong>
          </ion-label>
        </ion-item>

        <ag-grid-angular
          c3DarkTable
          [modules]="agModules"
          [rowData]="rowData"
          [columnDefs]="columnDefs"
          [gridOptions]="agGridOptions"
        >
        </ag-grid-angular>

        <div
          *ngIf="!calculatedParams.capecitabine150NotEmpty"
          class="c3-flex ion-align-items-center ion-margin-top"
        >
          <ion-icon
            size="large"
            color="secondary"
            class="ion-margin-end"
            [src]="'information-outline' | getIcon"
          >
          </ion-icon>
          <p>
            La terapia a base di <strong>{{ ONCO_DRUGS[0].name }}</strong> calcolata
            <strong>non</strong> prevede assunzioni di farmaco. Pertanto <strong>non</strong> verrà
            prescritta.
          </p>
        </div>

        <div
          *ngIf="!calculatedParams.capecitabine500NotEmpty"
          class="c3-flex ion-align-items-center ion-margin-top"
        >
          <ion-icon
            size="large"
            color="secondary"
            class="ion-margin-end"
            [src]="'information-outline' | getIcon"
          >
          </ion-icon>
          <p>
            La terapia a base di <strong>{{ ONCO_DRUGS[1].name }}</strong> calcolata
            <strong>non</strong> prevede assunzioni di farmaco. Pertanto <strong>non</strong> verrà
            prescritta.
          </p>
        </div>
      </ion-col>

      <!-- ---------------------------------------------------------------------------------------------------- -->

      <!-- notes -->
      <ion-col size="12" size-md="12">
        <h3>Altro</h3>

        <ion-item>
          <ion-label position="stacked">Note</ion-label>
          <ion-textarea
            formControlName="notes"
            #notesInput
            maxlength="10000"
            autoGrow
            rows="2"
          ></ion-textarea>
        </ion-item>

        <div class="c3-validation-box-stacked c3-flex ion-justify-content-between">
          <ion-note>Eventuali note da allegare alla terapia</ion-note>
          <ion-note
            ><small>{{ notesInput.value?.length || 0 }}/10000</small></ion-note
          >
        </div>
      </ion-col>
    </ion-row>
  </ion-grid>
</form>
